import { useCallback, useMemo } from 'react';
import { useGetMacrosQuery } from '../../__generated__/chirp/com/hubspot/cv/macros/rpc/MacroRpc.hooks';
import { MacrosMenuList } from './MacrosMenuList';
import { MacrosEmptyStatePopover } from './MacrosEmptyStatePopover';
import { jsx as _jsx } from "react/jsx-runtime";
export const MacrosMenu = ({
  onSelectMacro,
  macrosMenuConfig,
  insertMacroText
}) => {
  const {
    data: macrosData,
    error,
    loading
  } = useGetMacrosQuery();
  const {
    portalIsEnterprise,
    userIsAdmin,
    hasMacrosScope
  } = macrosMenuConfig;
  const sortedMacros = useMemo(() => {
    if (!(macrosData !== null && macrosData !== void 0 && macrosData.results)) {
      return [];
    }
    return [...macrosData.results].sort((a, b) => a.name.localeCompare(b.name));
  }, [macrosData === null || macrosData === void 0 ? void 0 : macrosData.results]);
  const handleSelectMacro = useCallback(macro => {
    if (macro.message) {
      insertMacroText(macro.message);
    }
    onSelectMacro(macro);
  }, [insertMacroText, onSelectMacro]);
  return sortedMacros.length > 0 && hasMacrosScope ? /*#__PURE__*/_jsx(MacrosMenuList, {
    macros: sortedMacros,
    onSelectMacro: handleSelectMacro
  }) : /*#__PURE__*/_jsx(MacrosEmptyStatePopover, {
    isAdmin: userIsAdmin,
    hasMacrosScope: hasMacrosScope,
    portalIsEnterprise: portalIsEnterprise,
    loading: loading,
    error: !!error,
    macros: sortedMacros
  });
};
MacrosMenu.displayName = 'MacrosMenu';